import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/**
 * Statut d'une feuille d'heures (enum App\Entity\TimeSheetStatus de l'API, GET /time_sheet_statuses) : Brouillon,
 * Soumise, En attente du manager, En attente du Dirigeant, Validée, Refusée ; position : ordre d'affichage (celui du
 * parcours d'une feuille)
 */
export default class TimeSheetStatusModel extends AbstractApiModel {
  protected _path = '/time_sheet_statuses/{?id}';

  @doc.string declare reference: string;
  @doc.string declare label: string;

  /** Ordre d'affichage ; undefined si l'API ne le donne pas */
  get position(): number | undefined {
    return this.get<number | undefined, undefined>('position', undefined);
  }

  /** URN à envoyer à l'API pour écrire la relation (corps d'un POST / PATCH) ; un filtre prend l'id */
  get urn(): string {
    return this.get<string, string>('@urn', `$:teiji:time_sheet_status:${this.id}`);
  }
}
